// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_ins","cls2":"UserCard-cls2_wXB UserCard-cls1_ins","truncateText":"UserCard-truncateText_Pkh"};